import {
  date_tile_default
} from "./chunk-JUBPWQ5P.js";

// src/blocks/date-tile/index.ts
var date_tile_default2 = date_tile_default;

export {
  date_tile_default2 as date_tile_default
};
